import React from "react";
import "styles/Home.css";
import { AnimatedSection, ScrollAnimations } from "hooks/useScrollAnimations";
import HeroNew from "./HeroNew";
import HotelsSection from "./Hotels/HotelsSection";

const Home = () => {
  return (
    <ScrollAnimations>
      <HeroNew />
      <AnimatedSection className="slide-up">
        <HotelsSection />
      </AnimatedSection>
    </ScrollAnimations>
  );
};

export default Home;
